import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'HOME',
        about: 'ABOUT',
        board: 'BOARD OF DIRECTORS',
        products: 'PRODUCTS',
        investor: 'INVESTOR RELATIONS',
        factory: 'OUR FACTORY',
        partners: 'SUCCESS PARTNERS',
        media: 'MEDIA CENTER',
        gallery: 'GALLERY',
        contact: 'CONTACT US',
        language: 'Language'
      },
      contact: {
        email: 'forging-info@mih.eg',
        phone1: '0225430426',
        phone2: '0225430427'
      },
      hero: {
        title: 'AL NASR FORGING OFFICIAL WEBSITE',
        titleLine1: 'AL NASR',
        titleLine2: 'FORGING OFFICIAL WEBSITE',
        subtitle: 'Considered the largest forging plant in Egypt and Middle East. Established in 1960.',
        readMore: 'Read More',
        scroll: 'Scroll Down'
      },
      chairman: {
        title: 'CHAIRMAN SPEECH',
        name: 'Ashraf Abdel Salam',
        position: 'CEO',
        imageAlt: 'Chairman of Al Nasr Forging Company',
        speech: 'Al Nasr forging industry works according to the holding company\'s strategy in institutional development for individuals and equipment with the aim of improving the overall performance of the company through, continuing to obtain new marketing sources, and striving towards improving product quality, and searching for new product manufacture as per the market demand, and working on Maximizing profitability by increasing worker and equipment productivity while rationalizing consumption and working continuously towards qualifying workers technically and administratively to keep pace with all developments and competition.'
      },
      social: {
        title: 'SOCIAL RESPONSIBILITY',
        description: 'Nasr forging company pays great attention to the surrounding environment as it plays its full role towards it in preserving it by adhering to environmental conditions and taking all measures that it maintains through environmental protection projects where the company has: – By switching to gas and electricity instead of diesel to reduce exhaust and air pollution, and this through the installation of electrical induction furnaces To reduce noise pollution, the company turned pneumatic hammers into hydraulic and canceled the air pressure station The company also constructed an industrial sewage plant for recycling wastewater and used it in gardening and green planting We always strive to obtain quality certificates in environmental compliance and environmental management (ISO14001) Believing in the return of the commitment to the safety and occupational health of the economic and environmental workers, the company has committed to the tasks of prevention and obtaining an industrial security certificate (ISO45001)',
        certificatesTitle: 'CERTIFICATES',
        viewCertificate: 'View Certificate'
      },
      specialties: {
        seeMore: 'See More',
        item1: {
          title: 'Flanges',
          description: 'Forged and machined steel flanges for transportation lines of petroleum products, water and gases'
        },
        item2: {
          title: 'Chains',
          description: 'Steel chains according to German Standards (DIN) of diameter 13mm – 45mm calibrated'
        },
        item3: {
          title: 'Parts finished by C.N.C machines',
          description: 'Milling – Lathes – Drilling'
        },
        item4: {
          title: 'Laser cutting technology',
          description: 'Lasers are used to cut materials used in industrial manufacturing'
        },
        item5: {
          title: 'Automotive and engine industries',
          description: 'Forged parts for buses, lorries, tractors and engines such as Crankshafts, connecting rods, gears, axes, Hubs'
        },
        item6: {
          title: 'Railway and metro parts',
          description: 'Screw-couplings, Draw Hooks, collision columns, Clips for Railway fasteners, fixing, Rails Base, fish planets'
        },
        item7: {
          title: 'Forged parts',
          description: 'Special parts of electrical networks according to the customer\'s need'
        },
        item8: {
          title: 'Conveyors',
          description: 'Conveyors according to German Standards (DIN) of diameter 13mm – 45mm'
        }
      },
      products: {
        title: 'OUR PRODUCTS',
        subtitle: 'Comprehensive Forging Solutions for Every Industry',
        productDescription: 'Product Description',
        knowMore: 'Know More',
        items: [
          {
            id: 'chain-plant',
            title: 'Chain Plant',
            shortDescription: 'Chains are produced according to DIN for tension and hoisting purposes',
            fullDescription: 'It has been constructed for manufacturing of metallic chain for tensions and hoisting purpose, and general purpose as well. This shop was modernized to scope the new trends of productions by supporting it with up to date manufacturing line from Germany. Chains are produced according to (DIN) standard to supply:\n\n1. Calibrated chains 6: 16 mm.\n2. Non-calibrated Chains 6: 40 mm.\n3. Special Chains according to Customers\' needs.\n4. Circular Link Chains.\n5. Chain attachments (Swivel - Shackle - End Links And Hooked).\n\nTo guarantee best properties we could get approval of LLOYDS REGISTER OF SHIPPING AS MANUFACTURER OF STEEL CHAINS.'
          },
          {
            id: 'din-forging-shop',
            title: 'DIN Forging Shop',
            shortDescription: 'Where parts are hot drop stamped up to 100 kg weight per piece',
            sections: [
              {
                title: 'DIN Forging Shop Equipment',
                content: 'Drop forging stamping or die stamping:\n• Hammers up to 10 t capacity\n• Horizontal forging hammers up to 1250 t capacity\n• Heating furnaces of different capacities\n• Handling facilities up to 10 t weight'
              },
              {
                title: 'Free Forging Shop',
                content: 'The shop produces free forgings of cylindrical shapes up to 300mm diameter, and 2t weight (for discs up to 800mm) diameter & 1000kg weight.\n\nEquipment:\n• Free forging hammers up to 3t capacity\n• Heating furnaces of different capacities\n• Handling facilities up to 5 t capacity'
              },
              {
                title: 'Machining and Die Making Shops',
                content: 'The shops contain:\n• Horizontal lathes for diameters up to 1000mm and lengths to 5000mm\n• Drills: Upright and radial drill up to 80mm diameter\n• Broaching machine up to 7 mm\n• Grinding Machine: Surface grinding up to 320 x 100mm, Inner cylindrical grinding up to 80mm, Outer cylindrical grinding up to 200mm Diameter and 2000mm length, Centerless grinding up to 50mm\n• Vertical milling machine different sizes (Plano-milling) machines up to 2000 x 8000mm\n• Vertical copy milling machine\n• Special machine for manufacturing of helical gears up to 750mm and normal gears up to 1250mm, module up to 12\n• Spark erosion die-making machine'
              },
              {
                title: 'Heat Treatment Shops',
                content: 'The shop are equipped with fully automatic controlled pusher type furnaces of high productivity. All heat treatment operations are performed (normalizing – annealing – hardening tempering - etc.). There are induction surface treatment high – frequency units and salt baths for treating of tool steels. Surface carburizing is also performed in our shops.'
              },
              {
                title: 'Die Manufacturing Shop',
                content: 'We also have a Die manufacturing Shop within the company, this shop contains on lines: (horizontal lathes, vertical lathes, drill lines – grinding machine lines – milling lines – planer lines, CNC millers and laser cutting machine)'
              }
            ]
          },
          {
            id: 'automotive-tractor',
            title: 'Automotive and Tractor Manufactures',
            shortDescription: 'Forged parts consist 25-40% of the weight of any tractor, bus or lorry',
            sections: [
              {
                title: 'Engine',
                content: 'Crank shaft, Camshaft, connecting Rod and Rocker Arm etc.'
              },
              {
                title: 'Gear box',
                content: 'Various gears, rods and transmission levers.'
              },
              {
                title: 'Mechanical and suspension',
                content: 'Parts, like Front Axles – Rear Axles-Crown Gears-Front and Rear Hubs – Connecting parts-brake details- Steering Arm'
              }
            ]
          },
          {
            id: 'railway-needs',
            title: 'Railway Needs',
            shortDescription: 'Buffer rods, tracking hooks, screw couplings, suspension groups, and various types of pins',
            sections: [
              {
                title: 'Railway Components',
                content: 'The company manufactures the following railroad missions:\n\nAll kinds of Buffer rods – traction hooks – screw coupling -suspension group – various type of all the pins according to international standards.\nBrake Details- railway clips – Bolts for connecting rods with each other – Rail bases – Clips U – Fishplate.'
              },
              {
                title: 'Quality Assurance',
                content: 'Spare parts for railway forgings is the best quality Because take care to produce all railway parts according to international standards. All parts of the railway are subjected during the production stages to many very precise production processes, starting from the stages of selecting the raw materials through the procedures for preparing the raw materials and the production steps: (Cutting and hammering ores using hammers – heat treatments – finishing)'
              }
            ]
          },
          {
            id: 'petroleum-industry',
            title: 'Petroleum Industry',
            shortDescription: 'We supply petroleum companies with various types of steel flanges',
            fullDescription: 'We supply petroleum companies with various types of steel flanges (blind - slip on - welding neck - threaded) 1/2"-24" at working pressures (150-600) lb/inch² according to standard specifications.'
          },
          {
            id: 'military-factories',
            title: 'Military Factories and Industries',
            shortDescription: 'We supply them with all their needs from the forged parts suitable for heavy duty',
            fullDescription: 'We supply them with all their needs from the forged parts suitable for heavy duty.'
          },
          {
            id: 'machine-building',
            title: 'Machine Building Industry',
            shortDescription: 'We supply machine Building factories with all forged parts for manufacturing',
            fullDescription: 'We supply machine Building factories with all forged parts for manufacturing. Of lathes, milling machines, planning machine, shears and details for Agricultural machine.'
          },
          {
            id: 'irrigation-drainage',
            title: 'Irrigation Authority - Land Reclamation Co. and Drainage',
            shortDescription: 'Parts for irrigation and drainage projects - Metallic conveyors of different design',
            sections: [
              {
                title: 'Irrigation and Drainage Parts',
                content: 'Parts for irrigation and drainage projects.'
              },
              {
                title: 'Metallic Conveyors',
                content: 'Metallic conveyors of different design.'
              }
            ]
          },
          {
            id: 'marine-companies',
            title: 'Marine Companies',
            shortDescription: 'Our Company produces the required parts for marine work',
            sections: [
              {
                title: 'Marine Components',
                content: 'Our Company produces the required parts marine work as:\n1- Parts for ship-landing and fastening.\n2- Chains and their accessories according to the international specifications under supervision of Lloyds Register of shipping'
              }
            ]
          },
          {
            id: 'weaving-spinning',
            title: 'Spare Parts for Weaving and Spinnings Industries',
            shortDescription: 'Driving gears of different types',
            sections: [
              {
                title: 'Weaving and Spinning Components',
                content: '• Driving gears of different types\n• Special gears\n• Tightening clips\n• The company also manufactures any spare-parts as customer request.'
              }
            ]
          },
          {
            id: 'food-sugar',
            title: 'Food and Sugar Industries',
            shortDescription: 'We supply these industries with different chains and their accessories',
            fullDescription: 'We supply these industries with different chains and their accessories mechanical transportation conveyors for production processes and their spare parts.'
          }
        ]
      },
      footer: {
        description: 'Considered the largest forging plant in Egypt and Middle East. Established in 1960.',
        quickLinks: 'QUICK LINKS',
        moreLinks: 'MORE LINKS',
        contact: 'CONTACT US',
        copyright: 'Copyright 2026 AL NASR FORGING | All Rights Reserved | Powered by OK Media Co.'
      },
      board: {
        title: 'BOARD OF DIRECTORS',
        members: [
          {
            name: 'Dr.Eng. Mohamed Ahmed Mostafa Elias',
            position: 'Chairman',
            phones: ['01221311300', '01150504039'],
            emails: ['Alayas@mail.com']
          },
          {
            name: 'Gen.Eng. Ashraf Abdalslam',
            position: 'Managing Director',
            phones: ['(02)25430425', '01099665366', '01115306880'],
            emails: ['forging-chairman@mih.eg', 'ashawd2012@yahoo.com']
          },
          {
            name: 'Eng. Galal abd Elaziz',
            position: 'Head of Technical Sector',
            phones: ['(02)25430429', '01113506007'],
            emails: ['galalabdelaziz075@gmail.com']
          },
          {
            name: 'Eng. Mohammed Elsbahy',
            position: 'Head of the productions sector',
            phones: ['(02)27155103', '01113786200'],
            emails: ['m.sabahey3322@yahoo.com']
          },
          {
            name: 'Eng. Khaled Elansary',
            position: 'Head of Maintenance sector',
            phones: ['01144301080'],
            emails: ['khaledansary390@gmail.com']
          },
          {
            name: 'Acc. Mohamed Abdel-Hay',
            position: 'Head of the financial sector',
            phones: ['(02)25430428', '01006372393'],
            emails: []
          },
          {
            name: 'Eng. Sanaa Mahmoud',
            position: 'General Manager of Design',
            phones: ['01103011687'],
            emails: ['Forging-info@mih.eg']
          },
          {
            name: 'Mr. Nasser Shebl',
            position: 'Head of the human resources sector',
            phones: ['01126668037'],
            emails: ['nasrshbl@gmail.com']
          },
          {
            name: 'Acc. Mohamed Abdel Fattah',
            position: 'Head of the Purchases Sector',
            phones: ['0113667344'],
            emails: ['Forging-procurement@mih.eg']
          }
        ]
      },
      about: {
        heroTitle: 'ABOUT US',
        introTitle: 'Leading the Forging Industry Since 1960',
        intro: 'El Nasr Forging Company is consider one of the main pillars in the steel industries sector, one of the largest forgings factories in Egypt and the Middle East, as it was established in 1960 as an intermediate manufacturing industry for the production of steel forgings and chains, and it was inaugurated in 1964',
        established: 'Established',
        yearsExperience: 'Years of Excellence',
        messageTitle: 'Company Message',
        messageSubtitle: 'Our Commitment to Excellence',
        message: 'Preserving the forgings industry in Egypt and distinguishing it so that the company becomes the first choice for all customers of the forgings industry in the Arab and African world by caring for the comprehensive quality in all our products, services and meeting the desires of our customers in the least time and with the highest performance and achieving their ambitions with our commitment to honesty in all Our dealings, developing the capabilities of our employees (our partners in success), and assuming social responsibility in order to serve our country and maximize the return on share capital',
        missionTitle: 'Our Mission',
        mission: [
          'Increasing production while achieving complete customer satisfaction by anticipating the local market while adhering to international standards and specifications',
          'Active participation in continuous improvement and innovation'
        ],
        visionTitle: 'Company Vision',
        vision: [
          'Developing the forging and chains industry, achieving self-sufficiency for the local market, and actively contributing to the enhancement and increase of local production.',
          'Seeking partnerships in management, financing, and operations to upgrade outdated production lines and boost competitiveness in line with the State Ownership Policy Document.',
          'Expanding into Arab and African markets as part of the Egyptian companies\' direction, in accordance with the State\'s Vision 2030.'
        ],
        targetTitle: 'Our Strategic Goals',
        targetSubtitle: 'Building the future of Egyptian industry',
        target: [
          'Work within the plan to develop our country, Egypt with a vision for the future 2030.',
          'Attracting the largest segment of the Egyptian market, striving to export, seeking new customers, and manufacturing new products required for the Egyptian market.',
          'Achieve customer demands in the least time than planned and with high quality.',
          'Development of production technology to keep pace with development in quality systems and customer service.',
          'Work within a plan (annual – monthly – daily) to increase production.',
          'Deepening cooperation with the private sector (suppliers – clients) while seeking to partner with other companies to win new clients.',
          'Confronting and treating inherited problems.',
          'Developing the existing equipment at the lowest costs and striving to acquire the latest capabilities of the company in stages',
          'Following a policy of rationalization in materials, energy and labor.'
        ]
      },
      factory: {
        title: 'OUR FACTORIES',
        factories: [
          {
            id: 'heat-treatment',
            title: 'Heat Treatment Shop',
            description: 'The shops is equipped with fully automatic controlled pusher type urn aces of height productivity There are induction surface treatment height – frequency units and salt baths for treating of tool steels .'
          },
          {
            id: 'forging',
            title: 'Forging Shops',
            description: 'The plant includes Die forging shop with die up to 100 kg. and Free forging shop product cylindrical shapes up 300mm diameter and 2tons (for discs up to 800mm) diameter &1000kg weight .'
          },
          {
            id: 'chains',
            title: 'Chains Manufacturing Shop',
            description: 'production of chains according to the German specifications (DIN) for tensile and suspension'
          },
          {
            id: 'blanching',
            title: 'Blanching Shops',
            description: 'It includes Blanking press for Bar Cutting up to 140mm diameter – Disc saw Up to 500 mm diameter or 400 mm Square – Reciprocating saw Up to 120mm diameter.'
          },
          {
            id: 'spear-parts',
            title: 'Spear Parts and Die Production Shops',
            description: 'The lines of horizontal lathes and Vertical lathes- drills lines – Grinding lines – Milling lines – planers)'
          },
          {
            id: 'laser-cutting',
            title: 'Laser Cutting Shop',
            description: 'The machine used for cutting, drilling and arking by High Accuracy and fully computerized and The machine used for cutting all shapes and complicated solids'
          },
          {
            id: 'cnc',
            title: '(C.N.C) Machining Shop',
            description: '( Milling – Drills -Planers…… etc)'
          },
          {
            id: 'laboratories',
            title: 'Chemical and Mechanical Laboratories',
            description: 'Our company is equipped with most advanced laboratories for tests on  material  . products checking.'
          }
        ]
      },
      partners: {
        title: 'SUCCESS PARTNERS',
        subtitle: 'Our Partners in Success, Last 3 Years',
        million: 'Million',
        currency: 'EGP',
        partners: [
          {
            id: 'Egyptian Railways',
            amount: '1',
            image: '16-1.jpg'
          },
          {
            id: 'Partner-2',
            amount: '30',
            image: 'images-200x200.png'
          },
          {
            id: 'Egyptian-Metro',
            amount: '4',
            image: '8-1.jpg'
          },
          {
            id: 'Partner-4',
            amount: '35',
            image: '7-1.jpg'
          },
          {
            id: 'Orascom-Construction',
            amount: '12',
            image: '26-1.jpg'
          },
          {
            id: 'Ministry-of-Military-Production',
            amount: '12',
            image: '11-1.jpg'
          },
          {
            id: 'samcrete-engineers-and-contractors',
            amount: '2',
            image: '19-1.jpg'
          },
          {
            id: 'Partner-8',
            amount: '6',
            image: '17-1.jpg'
          },
          {
            id: 'South-Delta-for-Electricity-Distribution-Company',
            amount: '2',
            image: '23-1.jpg'
          },
          {
            id: 'Behera-Company-for-Electricity-Distribution',
            amount: '1',
            image: '27-1.jpg'
          },
          {
            id: 'North-Cairo-Electricity-Distribution-Company',
            amount: '40',
            image: 'unnamed-6-200x200.jpg'
          },
          {
            id: 'Egyptian-Electricity-renewable-energy-company',
            amount: '10',
            image: 'unnamed-7-200x192.jpg'
          },
          {
            id: 'ESIIC',
            amount: '5',
            image: '2-1.jpg'
          },
          {
            id: 'COLAS-RAIL',
            amount: '16',
            image: '6-1.jpg'
          },
          {
            id: 'Al-Kharafi',
            amount: '40',
            image: '1631331127834.jpeg'
          },
          {
            id: 'Gharably-Integrated-Engineering-Co.',
            amount: '2',
            image: 'unnamed-9-200x148.jpg'
          },
          {
            id: 'Hassan-Allam-Properties',
            amount: '5',
            image: 'شركة-حسن-علام-العقارية-200x200.jpg'
          },
          {
            id: 'Elsewedy-Electric',
            amount: '16',
            image: 'unnamed-12.jpg'
          },
          {
            id: 'Dahab',
            amount: '8',
            image: 'unnamed-11-200x192.jpg'
          },
          {
            id: 'Reliance',
            amount: '2',
            image: '4-1jpg'
          },
        ]
      },
      contactPage: {
        title: 'CONTACT US',
        address: {
          title: 'Factory Address',
          line1: 'EL - Tabbin - Helwan',
          line2: 'Telecomunication Matrokat',
          line3: 'P.O.P 15 Helwan'
        },
        phones: {
          executive: {
            title: 'Executive Managing Director Office',
            number: '(202) 25430425'
          },
          boardFax: {
            title: 'Board Fax',
            number: '(202) 25430426'
          },
          marketing: {
            title: 'Marketing & Sales',
            number: '(202) 25430427'
          },
          financial: {
            title: 'Financial Department',
            number: '(202) 25430428'
          },
          quality: {
            title: 'Quality Sector',
            number: '(202) 25430429'
          }
        },
        workingHours: {
          title: 'Working Hours',
          weekdays: 'Sunday to Thursday',
          time: '8:00 AM to 4:00 PM',
          weekend: 'Friday and Saturday off'
        },
        emails: {
          info: 'forging-info@mih.eg',
          sales: 'forging-sales@mih.eg'
        },
        map: {
          title: 'Our Location'
        },
        marketingTeam: {
          title: 'Marketing Team'
        }
      },
      investor: {
        title: 'INVESTOR RELATIONS',
        backToInvestorRelations: 'Back to Investor Relations',
        contactCtaTitle: 'Interested in this project?',
        contactCtaText: 'Contact us for more information and custom solutions',
        tabs: {
          businessResults: 'Business Results',
          financialCenter: 'Financial Center',
          rulesRegulations: 'Rules and Regulations',
          ourProjects: 'Our Projects',
          presentations: 'Presentations'
        },
        businessResults: {
          title: 'Business Results',
          content: 'Our business results showcase the company\'s performance and achievements. This section contains detailed information about our financial performance, operational metrics, and strategic milestones.',
          images: []
        },
        financialCenter: {
          title: 'Financial Center',
          content: 'The Financial Center provides comprehensive financial information including annual reports, quarterly statements, and financial analyses. Access detailed financial data and performance indicators.',
          images: []
        },
        rulesRegulations: {
          title: 'Rules and Regulations',
          content: 'This section contains all relevant rules, regulations, and compliance information. Stay informed about corporate governance, regulatory requirements, and legal frameworks that govern our operations.',
          images: []
        },
        ourProjects: {
          title: 'Our Projects',
          content: 'Explore our current and completed projects. This section highlights our major initiatives, development projects, and strategic investments that drive our growth and expansion.',
          learnMore: 'Learn More',
          details: 'Project Details',
          images: []
        },
        presentations: {
          title: 'Presentations',
          content: 'Access our investor presentations, annual reports presentations, and strategic overviews. Download materials from investor meetings, conferences, and corporate events.',
          images: []
        }
      },
      media: {
        title: 'MEDIA CENTER',
        tabs: {
          news: 'News',
          multimediaGallery: 'Multimedia Gallery',
          socialMedia: 'Social Media'
        },
        news: {
          title: 'News',
          content: 'Stay updated with the latest news and announcements from Al Nasr Forging Company. This section contains press releases, company updates, and industry news.',
          images: []
        },
        multimediaGallery: {
          title: 'Multimedia Gallery',
          content: 'Explore our multimedia gallery featuring videos, images, and interactive content showcasing our facilities, processes, and achievements.',
          images: []
        },
        socialMedia: {
          title: 'Social Media',
          content: 'Connect with us on social media platforms. Follow our latest updates, behind-the-scenes content, and engage with our community.',
          images: []
        },
        readMore: 'Read More'
      }
    }
  },
  ar: {
    translation: {
      nav: {
        home: 'الرئيسية',
        about: 'عن الشركة',
        board: 'مجلس الإدارة',
        products: 'المنتجات',
        investor: 'علاقات المستثمرين',
        factory: 'مصنعنا',
        partners: 'شركاء النجاح',
        media: 'المركز الإعلامي',
        gallery: 'المعرض',
        contact: 'اتصل بنا',
        language: 'اللغة'
      },
      contact: {
        email: 'forging-info@mih.eg',
        phone1: '0225430426',
        phone2: '0225430427'
      },
      hero: {
        title: 'الموقع الرسمي لشركة النصر للمطروقات',
        titleLine1: 'النصر',
        titleLine2: 'الموقع الرسمي للمطروقات',
        subtitle: 'تعتبر أكبر مصنع للمطروقات في مصر والشرق الأوسط. تأسست في ١٩٦٠.',
        readMore: 'اقرأ المزيد',
        scroll: 'انتقل لأسفل'
      },
      chairman: {
        title: 'كلمة رئيس مجلس الإدارة',
        name: 'أشرف عبد السلام',
        position: 'الرئيس التنفيذي',
        imageAlt: 'رئيس مجلس إدارة شركة النصر للمطروقات',
        speech: 'تعمل شركة النصر لصناعة المطروقات وفقاً لاستراتيجة الشركة القابضة في التطوير المؤسسي للأفراد والمعدات بغرض تحسين الأداء العام للشركة من خلال – الاستمرار في الحصول على مصادر تسويقية جديده – و السعي الدؤوب نحو تحسين جودة المنتج – والبحث عن تصنيع منتجات جديده حسب طلب السوق – و العمل على تعظيم الربحية من خلال زيادة انتاجية العامل و المعدات مع ترشيد الاستهلاك و العمل بإستمرار نحو تأهيل العمال فنياً و إداراياً لمواكبة كافة التطوروات والمنافسة .'
      },
      social: {
        title: 'المسؤولية الاجتماعية',
        description: 'تولي شركة المطروقات إهتماماً كبيرا للبيئة المحيطه حيث تقوم بدورها الكامل  تجاهها في الحفاظ عليها بالالتزام بالشروط البيئية وإتخاذ كافة الإجراءات التي تحافظ عليها من خلال مشاريع حماية البيئة حيث قامت الشركة : – بالتحول للغاز و الكهرباء بدلاً عن السولار للحد من العوادم و تلوث الهواء وهذا من خلال تركيب أفران الحث الكهربائي و للحد من التلوث الضوضائي  قامت الشركة بتحويل المطارق الهوائية الي هيدروليكية و إلغاء محطة ضغط الهواء كما قامت الشركة بعمل محطة  صرف صناعي لعمليات تدوير مياه الصرف و استخدماها في زراعة الحدائق وزياردة الرقعه الخضراء و نسعى دائما في الحصول على شهادات الجودة في الالتزام البيئى و الادارة البيئية (ISO14001). و ايمانا منا بمردود الالتزام بالسلامه و الصحه المهنية للعاملين الاقتصادي والبيئي قامت الشركة  بالالتزام بمهمات الوقاية و الحصول علي شهادة الامن الصناعي (ISO45001)',
        certificatesTitle: 'الشهادات',
        viewCertificate: 'عرض الشهادة'
      },
      specialties: {
        seeMore: 'اقرأ المزيد',
        item1: {
          title: 'فلانشات',
          description: 'فلانشات صلب مطروقة و مشطبة لخطوط نقل المواد البترولية و المياه و الغازات'
        },
        item2: {
          title: 'كنابل',
          description: 'حسب مواصفات العمل DIN سلسلة قياسية من 13 مم إلى 45 مم'
        },
        item3: {
          title: 'إجزاء منتهيطبة بماكينات C.N.C',
          description: 'خراطه – ثقب – شكره'
        },
        item4: {
          title: 'تكنولوجيا تقطيع بالليزر',
          description: 'تستخدم الليزر لتقطيع المواد المستخدمة في التصنيع الصناعي'
        },
        item5: {
          title: 'صناعة السيارات والجرارات',
          description: 'أجزاء مطروقة للأتوبيس واللوري والجرار مثل أعمدة المرفق ( الكرنكات ) وأذرع التوصيل ( البلت ) والتروس والمحاور ( الاكسات )'
        },
        item6: {
          title: 'موصلات السكك الحديدية',
          description: 'وصلات الجر – خطاطيف الجر– أعمدة التصادم – الكليبسات الخاصة بتثبيت القضبان– وقواعد القضبان واللبنات'
        },
        item7: {
          title: 'أجزاء مطروقة',
          description: 'أجزاء خاصة من الشبكات الكهربائية حسب حاجة العميل'
        },
        item8: {
          title: 'سلاسل',
          description: 'سلاسل صلب طبقاً للمواصفات الألمانية ( DIN) من قطر 13مم – 45مم معايرة.'
        }
      },
      products: {
        title: 'منتجاتنا',
        subtitle: 'حلول مطروقة شاملة لكل صناعة',
        productDescription: 'وصف المنتج',
        knowMore: 'اعرف المزيد',
        items: [
          {
            id: 'chain-plant',
            title: 'مصنع السلاسل',
            shortDescription: 'إنتاج سلاسل وملحقاتها طبقاً للمواصفات الألمانية (DIN) لأغراض الشد والتعليق',
            fullDescription: 'تم إنشاؤه لتصنيع السلاسل المعدنية لأغراض الشد والتعليق والأغراض العامة أيضاً. تم تحديث هذا المصنع لمواكبة الاتجاهات الجديدة في الإنتاج من خلال دعمه بخط إنتاج حديث من ألمانيا. يتم إنتاج السلاسل وفقاً لمعيار (DIN) لتوريد:\n\n1. سلاسل معايرة 6: 16 مم.\n2. سلاسل غير معايرة 6: 40 مم.\n3. سلاسل خاصة وفقاً لاحتياجات العملاء.\n4. سلاسل حلقية.\n5. ملحقات السلاسل (الدوار - الكلبسة - الحلقات النهائية والخطاطيف).\n\nلضمان أفضل الخصائص، تمكنا من الحصول على موافقة سجل لويدز للشحن كصانع للسلاسل الفولاذية.'
          },
          {
            id: 'din-forging-shop',
            title: 'مصنع طرق بالأسطمبات',
            shortDescription: 'يتم الطرق بالأسطمبات حتى وزن 100 كجم',
            sections: [
              {
                title: 'معدات مصنع الطرق بالأسطمبات',
                content: 'طرق بالأسطمبات أو ختم بالأسطمبات:\n• مطارق حتى سعة 10 طن\n• مطارق الطرق الأفقية حتى سعة 1250 طن\n• أفران تسخين بسعات مختلفة\n• مرافق مناولة حتى وزن 10 طن'
              },
              {
                title: 'مصنع الطرق الحر',
                content: 'ينتج المصنع مطروقات حرة بأشكال أسطوانية حتى قطر 300 مم ووزن 2 طن (للأقراص حتى قطر 800 مم) ووزن 1000 كجم.\n\nالمعدات:\n• مطارق الطرق الحرة حتى سعة 3 طن\n• أفران تسخين بسعات مختلفة\n• مرافق مناولة حتى سعة 5 طن'
              },
              {
                title: 'ورش التشغيل وصناعة الأسطمبات',
                content: 'تحتوي الورش على:\n• مخارط أفقية لأقطار حتى 1000 مم وأطوال حتى 5000 مم\n• مثاقيب: مثقاب عمودي وقطري حتى قطر 80 مم\n• ماكينة برش حتى 7 مم\n• ماكينة تجليخ: تجليخ سطحي حتى 320 × 100 مم، تجليخ أسطواني داخلي حتى 80 مم، تجليخ أسطواني خارجي حتى قطر 200 مم وطول 2000 مم، تجليخ بدون مركز حتى 50 مم\n• ماكينة فرايز عمودية بأحجام مختلفة (ماكينات فرايز مستوية) حتى 2000 × 8000 مم\n• ماكينة فرايز عمودية نسخ\n• ماكينة خاصة لتصنيع التروس الحلزونية حتى 750 مم والتروس العادية حتى 1250 مم، موديول حتى 12\n• ماكينة تآكل كهربائي لصناعة الأسطمبات'
              },
              {
                title: 'ورش المعاملات الحرارية',
                content: 'الورش مجهزة بأفران دافعة أوتوماتيكية بالكامل عالية الإنتاجية. يتم تنفيذ جميع عمليات المعالجة الحرارية (التطبيع – التلدين – التقسية والمراجعة - إلخ). توجد وحدات معالجة سطحية بالحث عالية التردد وأحواض ملح لمعالجة فولاذ الأدوات. يتم أيضاً تنفيذ التكربن السطحي في ورشنا.'
              },
              {
                title: 'ورش صناعة الأسطمبات',
                content: 'لدينا أيضاً ورشة لصناعة الأسطمبات داخل الشركة، تحتوي هذه الورشة على خطوط: (مخارط أفقية، مخارط عمودية، خطوط المثاقيب – خطوط ماكينات التجليخ – خطوط الفرايز – خطوط المقاشط، فرايز CNC وماكينة قطع بالليزر)'
              }
            ]
          },
          {
            id: 'automotive-tractor',
            title: 'أجزاء سيارات وجرارات',
            shortDescription: 'تكون أجزاء المطروقات نسبة من 25 إلى 40% من وزن السيارة والجرار والأتوبيس واللوري',
            sections: [
              {
                title: 'المحرك',
                content: 'عمود المرفق، عمود الكامات، ذراع التوصيل وذراع الصمام إلخ.'
              },
              {
                title: 'صندوق التروس',
                content: 'تروس متنوعة، قضبان وذراع نقل الحركة.'
              },
              {
                title: 'الميكانيكا والتعليق',
                content: 'أجزاء مثل المحاور الأمامية – المحاور الخلفية – تروس التاج – المحاور الأمامية والخلفية – أجزاء التوصيل – تفاصيل الفرامل – ذراع التوجيه'
              }
            ]
          },
          {
            id: 'railway-needs',
            title: 'احتياجات سكة الحديد',
            shortDescription: 'أجزاء الفرامل - كلبسات تثبيت القضبان - بلنجات توصيل القضبان - قاعدة تثبيت القضبان',
            sections: [
              {
                title: 'مكونات السكك الحديدية',
                content: 'تقوم الشركة بتصنيع المهام التالية للسكك الحديدية:\n\nجميع أنواع أعمدة التصادم – خطاطيف الجر – وصلات براغي – مجموعة التعليق – أنواع مختلفة من جميع المسامير وفقاً للمعايير الدولية.\nتفاصيل الفرامل – كلبسات السكك الحديدية – براغي لتوصيل القضبان ببعضها البعض – قواعد القضبان – كلبسات U – بلنجات.'
              },
              {
                title: 'ضمان الجودة',
                content: 'قطع غيار المطروقات للسكك الحديدية هي الأفضل جودة لأننا نحرص على إنتاج جميع أجزاء السكك الحديدية وفقاً للمعايير الدولية. تخضع جميع أجزاء السكك الحديدية خلال مراحل الإنتاج للعديد من عمليات الإنتاج الدقيقة جداً، بدءاً من مراحل اختيار المواد الخام مروراً بإجراءات تحضير المواد الخام ومراحل الإنتاج: (القطع والطرق باستخدام المطارق – المعاملات الحرارية – التشطيب)'
              }
            ]
          },
          {
            id: 'petroleum-industry',
            title: 'صناعة البترول',
            shortDescription: 'نقوم بإمداد شركات البترول باحتياجاتها من الفلنشات المتنوعة',
            fullDescription: 'نقوم بإمداد شركات البترول باحتياجاتها من الفلنشات المتنوعة (عمياء - منزلقة - برقبة - مقلوظة) 1/2"-24" عند ضغوط عمل (150-600) رطل/بوصة² وفقاً للمواصفات القياسية.'
          },
          {
            id: 'military-factories',
            title: 'المصانع الحربية والصناعات',
            shortDescription: 'نوفر لهم جميع احتياجاتهم من الأجزاء المطروقة المناسبة للخدمة الشاقة',
            fullDescription: 'نوفر لهم جميع احتياجاتهم من الأجزاء المطروقة المناسبة للخدمة الشاقة.'
          },
          {
            id: 'machine-building',
            title: 'صناعة بناء الآلات',
            shortDescription: 'نزود مصانع بناء الآلات بجميع الأجزاء المطروقة للتصنيع',
            fullDescription: 'نزود مصانع بناء الآلات بجميع الأجزاء المطروقة للتصنيع. للمخارط، ماكينات الفرايز، ماكينات المقاشط، المقصات وتفاصيل الآلات الزراعية.'
          },
          {
            id: 'irrigation-drainage',
            title: 'هيئة الري وشركة استصلاح الأراضي والصرف',
            shortDescription: 'أجزاء لمشاريع الري والصرف - ناقلات معدنية بتصميمات مختلفة',
            sections: [
              {
                title: 'أجزاء الري والصرف',
                content: 'أجزاء لمشاريع الري والصرف.'
              },
              {
                title: 'ناقلات معدنية',
                content: 'ناقلات معدنية بتصميمات مختلفة.'
              }
            ]
          },
          {
            id: 'marine-companies',
            title: 'الشركات البحرية',
            shortDescription: 'تنتج شركتنا الأجزاء المطلوبة للأعمال البحرية',
            sections: [
              {
                title: 'مكونات بحرية',
                content: 'تنتج شركتنا الأجزاء المطلوبة للأعمال البحرية:\n1- أجزاء للرسو والتثبيت.\n2- سلاسل وملحقاتها وفقاً للمواصفات الدولية تحت إشراف سجل لويدز للشحن'
              }
            ]
          },
          {
            id: 'weaving-spinning',
            title: 'قطع غيار لصناعات النسيج والغزل',
            shortDescription: 'تروس دافعة من أنواع مختلفة',
            sections: [
              {
                title: 'مكونات النسيج والغزل',
                content: '• تروس دافعة من أنواع مختلفة\n• تروس خاصة\n• كلبسات شد\n• تقوم الشركة أيضاً بتصنيع أي قطع غيار حسب طلب العميل.'
              }
            ]
          },
          {
            id: 'food-sugar',
            title: 'صناعات الغذاء والسكر',
            shortDescription: 'نزود هذه الصناعات بسلاسل مختلفة وملحقاتها',
            fullDescription: 'نزود هذه الصناعات بسلاسل مختلفة وملحقاتها ناقلات نقل ميكانيكية لعمليات الإنتاج وقطع غيارها.'
          }
        ]
      },
      footer: {
        description: 'تعتبر أكبر مصنع للمطروقات في مصر والشرق الأوسط. تأسست في ١٩٦٠.',
        quickLinks: 'روابط سريعة',
        moreLinks: 'المزيد',
        contact: 'اتصل بنا',
        copyright: 'حقوق النشر ٢٠٢٦ شركة النصر للمطروقات | جميع الحقوق محفوظة | تطوير شركة أوكي ميديا'
      },
      board: {
        title: 'مجلس الإدارة',
        members: [
          {
            name: 'د.م. محمد أحمد مصطفى إلياس',
            position: 'رئيس مجلس الإدارة',
            phones: ['٠١٢٢١٣١١٣٠٠', '٠١١٥٠٥٠٤٠٣٩'],
            emails: ['Alayas@mail.com']
          },
          {
            name: 'لواء.م. أشرف عبد السلام',
            position: 'المدير التنفيذي',
            phones: ['(٠٢)٢٥٤٣٠٤٢٥', '٠١٠٩٩٦٦٥٣٦٦', '٠١١١٥٣٠٦٨٨٠'],
            emails: ['forging-chairman@mih.eg', 'ashawd2012@yahoo.com']
          },
          {
            name: 'م. جلال عبد العزيز',
            position: 'رئيس القطاع الفني',
            phones: ['(٠٢)٢٥٤٣٠٤٢٩', '٠١١١٣٥٠٦٠٠٧'],
            emails: ['galalabdelaziz075@gmail.com']
          },
          {
            name: 'م. محمد الصباحي',
            position: 'رئيس قطاع الإنتاج',
            phones: ['(٠٢)٢٧١٥٥١٠٣', '٠١١١٣٧٨٦٢٠٠'],
            emails: ['m.sabahey3322@yahoo.com']
          },
          {
            name: 'م. خالد الأنصاري',
            position: 'رئيس قطاع الصيانة',
            phones: ['٠١١٤٤٣٠١٠٨٠'],
            emails: ['khaledansary390@gmail.com']
          },
          {
            name: 'محاسب. محمد عبد الحي',
            position: 'رئيس القطاع المالي',
            phones: ['(٠٢)٢٥٤٣٠٤٢٨', '٠١٠٠٦٣٧٢٣٩٣'],
            emails: []
          },
          {
            name: 'م. سناء محمود',
            position: 'المدير العام للتصميم',
            phones: ['٠١١٠٣٠١١٦٨٧'],
            emails: ['Forging-info@mih.eg']
          },
          {
            name: 'السيد. ناصر شبل',
            position: 'رئيس قطاع الموارد البشرية',
            phones: ['٠١١٢٦٦٦٨٠٣٧'],
            emails: ['nasrshbl@gmail.com']
          },
          {
            name: 'محاسب. محمد عبد الفتاح',
            position: 'رئيس قطاع المشتريات',
            phones: ['٠١١٣٦٦٧٣٤٤'],
            emails: ['Forging-procurement@mih.eg']
          }
        ]
      },
      about: {
        heroTitle: 'عن الشركة',
        introTitle: 'رائدة صناعة المطروقات منذ ١٩٦٠',
        intro: 'تعتبر شركة النصر لصناعة المطروقات احد الركائز الأساسية فى قطاع صناعات الصلب من أكبر مصانع المطروقات فى مصر و الشرق الاوسط حيث أنشئت عام 1960 كصناعة تحويلية وسيطة لإنتاج المطروقات الصلب و الصناعات الحديدية و تم الافتتاح عام 1964',
        established: 'التأسيس',
        yearsExperience: 'عام من التميز',
        messageTitle: 'رسالة الشركة',
        messageSubtitle: 'التزامنا بالتميز',
        message: 'المحافظة علي صناعة المطروقات في مصر و التميز بها لكي تصبح الشركة هي الأختيار الأول لكافة عملاء صناعة المطروقات في الوطن العربي و الافريقي عن طريق الأهتمام بالجودة الشاملة في كافة منتجاتنا وخدماتنا وتلبية رغبات عملائنا في اقل وقت و بأعلى أداء و تحقيق طموحاتهم مع التزامنا بالصدق في كافة تعاملاتنا، وتطوير قدرات العاملين معنا (شركاؤنا في النجاح)، وتحمل المسئولية الإجتماعية من أجل خدمة وطننا وتعظيم العائد علي رأس المال.',
        missionTitle: 'مهمتنا',
        mission: [
          'زيادة الإنتاج مع تحقيق الرضا التام للعملاء من خلال توقع السوق المحلي مع الالتزام بالمعايير و المواصفات الدولية',
          'المشاركه الفعاله في التحسين المستمر و الابتكار'
        ],
        visionTitle: 'رؤية الشركة',
        vision: [
          'تطوير صناعه المطروقات و السلاسل وتحقيق الاكتفاء الذاتى للسوق المحلى والمشاركه الفعالة فى تعميق وزيادة المنتج المحلى.',
          'السعى الى الشراكة فى الادارة والتمويل والتشغيل لتطوير خطوط الانتاج المتقادمة لزيادة التنافسية طبقا لوثيقة ملكية الدولة.',
          'التوجه ضمن الشركات المصرية الي الأسواق العربية و الافريقية طبقاً لرؤية الدولة 2030.'
        ],
        targetTitle: 'أهدافنا الاستراتيجية',
        targetSubtitle: 'بناء مستقبل الصناعة المصرية',
        target: [
          'العمل ضمن مخطط تطوير بلدنا الغالية مصر برؤية مستقبلية 2030.',
          'جذب أكبر شريحة من السوق المصرى و السعي نحو التصدير والبحث عن عملاء جدد و تصنيع منتجات جديدة مطلوبة للسوق المصري.',
          'تحقيق مطالب العملاء في اقل وقت من المخطط و بالجودة العالية.',
          'تطوير تكنولجيا الانتاج لمواكبة التطور في أنظمة الجودة و خدمة العملاء.',
          'العمل ضمن مخطط (سنوي – شهري- يومي) لزيادة الإنتاج.',
          'تعميق التعاون مع القطاع الخاص (موردين- عملاء) مع السعى للشراكة مع شركات أخرى لكسب عملاء جدد.',
          'مواجهة المشكلات الموروثة و علاجها.',
          'تطوير المعدات الموجودة بأقل تكاليف و السعي نحو امتلاك الأحدث بإمكانيات الشركة على مراحل',
          'إتباع سياسية الترشيد في الخامات و الطاقة و العمالة'
        ]
      },
      factory: {
        title: 'مصانعنا',
        factories: [
          {
            id: 'heat-treatment',
            title: 'عنبر 6 (المعاملات الحرارية)',
            description: 'مصنع المعاملات الحرارية : توجد بالشركة أفران معالجة حرارية حديثة تعمل آليا بمعدل إنتاج عالى – وحدات ذبذبة للتقسية السطحية وافران إصلاح .'
          },
          {
            id: 'forging',
            title: 'عنابر الطرق',
            description: 'مصانع الطرق  : وتضم مصنع الطرق بالاسطمبات حتى وزن 100كجم – مصنع الطرق للأشكال الاسطوانية حتى قطر 300مم بوزن 2000كجم و للاجزاء ذات الأشكال القرصية حتى قطر 800مم بوزن 1000كجم 0'
          },
          {
            id: 'chains',
            title: 'عنبر 2 (السلاسل)',
            description: 'مصنع السلاسل : إنتاج سلاسل  و ملحقاتها طبقا للمواصفات الألمانية ( DIN  ) لأغراض الشد  والتعليق 0'
          },
          {
            id: 'blanching',
            title: 'عنبر 1 (التقطيع)',
            description: 'التقطيع : ويضم مكابس حتى 140مم – مناشير صنية حتى قطر 500مم أو مربع 400مم – مناشير ترددية حتى قطر 120مم 0'
          },
          {
            id: 'spear-parts',
            title: 'مصانع التشطيب و الاسطمبات',
            description: 'مصانع التشطيب والاسطمبات : وتضم خطوط المخارط الافقية و المخارط الراسية  خطوط المثاقيب – خطوط ماكينات التجليخ – خطوط الفرايز – خطوط المقاشط'
          },
          {
            id: 'laser-cutting',
            title: 'مصنع التقطيع بالليزر',
            description: 'باستخدام ماكينات الليزر للتقطيع دقيق'
          },
          {
            id: 'cnc',
            title: 'مصنع C.N.C',
            description: 'مصنع   (CNC) : لأعمال التشغيل بإستخدام ماكينات (CNC) ( خراطه – ثقب –  شنكره – و العديد من الأعمال  عالية الدقة و الجودة ….إلخ)'
          },
          {
            id: 'laboratories',
            title: 'وحدة المعامل الكيمياوية والميكانيكية',
            description: 'فتوجد بالشركة معامل حديثة لعمل اختبارات على الخامات و على المنتجات و استخراج شهادات للمنتج'
          }
        ]
      },
      partners: {
        title: 'شركاء النجاح',
        subtitle: 'شركاؤنا في النجاح، آخر 3 سنوات',
        million: 'مليون',
        currency: 'جنيه',
        partners: [
          {
            id: 'Egyptian Railways',
            amount: '1',
            image: '16-1.jpg'
          },
          {
            id: 'Partner-2',
            amount: '30',
            image: 'images-200x200.png'
          },
          {
            id: 'Egyptian-Metro',
            amount: '4',
            image: '8-1.jpg'
          },
          {
            id: 'Partner-4',
            amount: '35',
            image: '7-1.jpg'
          },
          {
            id: 'Orascom-Construction',
            amount: '12',
            image: '26-1.jpg'
          },
          {
            id: 'Ministry-of-Military-Production',
            amount: '12',
            image: '11-1.jpg'
          },
          {
            id: 'samcrete-engineers-and-contractors',
            amount: '2',
            image: '19-1.jpg'
          },
          {
            id: 'Partner-8',
            amount: '6',
            image: '17-1.jpg'
          },
          {
            id: 'South-Delta-for-Electricity-Distribution-Company',
            amount: '2',
            image: '23-1.jpg'
          },
          {
            id: 'Behera-Company-for-Electricity-Distribution',
            amount: '1',
            image: '27-1.jpg'
          },
          {
            id: 'North-Cairo-Electricity-Distribution-Company',
            amount: '40',
            image: 'unnamed-6-200x200.jpg'
          },
          {
            id: 'Egyptian-Electricity-renewable-energy-company',
            amount: '10',
            image: 'unnamed-7-200x192.jpg'
          },
          {
            id: 'ESIIC',
            amount: '5',
            image: '2-1.jpg'
          },
          {
            id: 'COLAS-RAIL',
            amount: '16',
            image: '6-1.jpg'
          },
          {
            id: 'Al-Kharafi',
            amount: '40',
            image: '1631331127834.jpeg'
          },
          {
            id: 'Gharably-Integrated-Engineering-Co.',
            amount: '2',
            image: 'unnamed-9-200x148.jpg'
          },
          {
            id: 'Hassan-Allam-Properties',
            amount: '5',
            image: 'شركة-حسن-علام-العقارية-200x200.jpg'
          },
          {
            id: 'Elsewedy-Electric',
            amount: '16',
            image: 'unnamed-12.jpg'
          },
          {
            id: 'Dahab',
            amount: '8',
            image: 'unnamed-11-200x192.jpg'
          },
          {
            id: 'Reliance',
            amount: '2',
            image: '4-1jpg'
          }
        ]
      },
      contactPage: {
        title: 'اتصل بنا',
        address: {
          title: 'عنوان المصنع',
          line1: 'التبين - حلوان',
          line2: 'الاتصالات المطروقات',
          line3: 'ص.ب 15 حلوان'
        },
        phones: {
          executive: {
            title: 'مكتب المدير التنفيذي',
            number: '(202) 25430425'
          },
          boardFax: {
            title: 'فاكس مجلس الإدارة',
            number: '(202) 25430426'
          },
          marketing: {
            title: 'التسويق والمبيعات',
            number: '(202) 25430427'
          },
          financial: {
            title: 'القسم المالي',
            number: '(202) 25430428'
          },
          quality: {
            title: 'قطاع الجودة',
            number: '(202) 25430429'
          }
        },
        workingHours: {
          title: 'ساعات العمل',
          weekdays: 'من الأحد إلى الخميس',
          time: 'من 8 صباحاً إلى 4 مساءً',
          weekend: 'الجمعة والسبت إجازة'
        },
        emails: {
          info: 'forging-info@mih.eg',
          sales: 'forging-sales@mih.eg'
        },
        map: {
          title: 'موقعنا'
        },
        marketingTeam: {
          title: 'فريق التسويق'
        }
      },
      investor: {
        title: 'علاقات المستثمرين',
        backToInvestorRelations: 'العودة إلى علاقات المستثمرين',
        contactCtaTitle: 'مهتم بهذا المشروع؟',
        contactCtaText: 'تواصل معنا لمزيد من المعلومات والحلول المخصصة',
        tabs: {
          businessResults: 'النتائج التجارية',
          financialCenter: 'المركز المالي',
          rulesRegulations: 'القواعد واللوائح',
          ourProjects: 'مشاريعنا',
          presentations: 'العروض التقديمية'
        },
        businessResults: {
          title: 'النتائج التجارية',
          content: 'تعرض نتائج أعمالنا أداء الشركة وإنجازاتها. يحتوي هذا القسم على معلومات مفصلة حول أدائنا المالي والمقاييس التشغيلية والمعالم الاستراتيجية.',
          images: []
        },
        financialCenter: {
          title: 'المركز المالي',
          content: 'يوفر المركز المالي معلومات مالية شاملة بما في ذلك التقارير السنوية والبيانات الربع سنوية والتحليلات المالية. الوصول إلى البيانات المالية التفصيلية ومؤشرات الأداء.',
          images: []
        },
        rulesRegulations: {
          title: 'القواعد واللوائح',
          content: 'يحتوي هذا القسم على جميع القواعد واللوائح ومعلومات الامتثال ذات الصلة. ابق على اطلاع حول حوكمة الشركات والمتطلبات التنظيمية والأطر القانونية التي تحكم عملياتنا.',
          images: []
        },
        ourProjects: {
          title: 'مشاريعنا',
          content: 'استكشف مشاريعنا الحالية والمكتملة. يسلط هذا القسم الضوء على مبادراتنا الكبرى ومشاريع التطوير والاستثمارات الاستراتيجية التي تدفع نمونا وتوسعنا.',
          learnMore: 'اعرف المزيد',
          details: 'تفاصيل المشروع',
          images: []
        },
        presentations: {
          title: 'العروض التقديمية',
          content: 'الوصول إلى عروضنا التقديمية للمستثمرين وعروض التقارير السنوية والملخصات الاستراتيجية. تنزيل المواد من اجتماعات المستثمرين والمؤتمرات والفعاليات المؤسسية.',
          images: []
        }
      },
      media: {
        title: 'المركز الإعلامي',
        tabs: {
          news: 'الأخبار',
          multimediaGallery: 'معرض الوسائط المتعددة',
          socialMedia: 'وسائل التواصل الاجتماعي'
        },
        news: {
          title: 'الأخبار',
          content: 'ابق على اطلاع بآخر الأخبار والإعلانات من شركة النصر للمطروقات. يحتوي هذا القسم على البيانات الصحفية وتحديثات الشركة وأخبار الصناعة.',
          images: []
        },
        multimediaGallery: {
          title: 'معرض الوسائط المتعددة',
          content: 'استكشف معرض الوسائط المتعددة الخاص بنا الذي يضم مقاطع الفيديو والصور والمحتوى التفاعلي الذي يعرض مرافقنا وعملياتنا وإنجازاتنا.',
          images: []
        },
        socialMedia: {
          title: 'وسائل التواصل الاجتماعي',
          content: 'تواصل معنا على منصات وسائل التواصل الاجتماعي. تابع آخر التحديثات والمحتوى خلف الكواليس وتفاعل مع مجتمعنا.',
          images: []
        },
        readMore: 'اقرأ المزيد'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

